class GridControls extends HTMLElement {
  constructor() {
    super();

    // this.storedSize = Cookies.get(`${window.cookiesPrefix}product_grid_size`);
    this.controls = this.querySelectorAll("button");
  }

  connectedCallback() {
    // this.setGridColumns();
    this.controls.forEach((control) => {
      control.addEventListener("click", this.onControlClick.bind(this));
    });
    // window.addEventListener("popstate", this.setGridColumns());
  }

  setGridColumns() {
    if (!this.storedSize) return;
    document.documentElement.style.setProperty("--product-grid-columns-size", `var(--product-grid-columns-size-${this.storedSize})`);
    this.controls.forEach((control) => {
      control.setAttribute("data-active", "false");
    });
    this.querySelector(`button[data-size="${this.storedSize}"]`).setAttribute("data-active", "true");
  }

  onControlClick(e) {
    const size = e.currentTarget.dataset.size;
    this.controls.forEach((control) => {
      control.setAttribute("data-active", "false");
    });
    e.currentTarget.setAttribute("data-active", "true");
    document.documentElement.style.setProperty("--product-grid-columns-size", `var(--product-grid-columns-size-${size})`);
    // Cookies.set(`${window.cookiesPrefix}product_grid_size`, size);
  }
}

customElements.define("grid-controls", GridControls);
